import type { Point } from "./model";
export interface Camera {
  scale: number;
  x: number;
  y: number;
}
export const FIT: Camera = { scale: 1, x: 0, y: 0 };
export function clampCamera(c: Camera, width: number): Camera {
  const scale = Math.max(1, Math.min(6, c.scale));
  const min = width * (1 - scale);
  return { scale, x: Math.max(min, Math.min(0, c.x)), y: Math.max(min, Math.min(0, c.y)) };
}
export function zoomAt(c: Camera, scale: number, anchor: Point, width: number): Camera {
  const bounded = Math.max(1, Math.min(6, scale));
  const ratio = bounded / c.scale;
  return clampCamera(
    { scale: bounded, x: anchor.x - (anchor.x - c.x) * ratio, y: anchor.y - (anchor.y - c.y) * ratio },
    width,
  );
}
export function pinchCamera(c: Camera, from: [Point, Point], to: [Point, Point], width: number): Camera {
  const mid = (ps: [Point, Point]) => ({ x: (ps[0].x + ps[1].x) / 2, y: (ps[0].y + ps[1].y) / 2 });
  const distance = (ps: [Point, Point]) => Math.hypot(ps[0].x - ps[1].x, ps[0].y - ps[1].y);
  const a = mid(from),
    b = mid(to);
  const scale = Math.max(1, Math.min(6, (c.scale * distance(to)) / Math.max(1, distance(from))));
  const ratio = scale / c.scale;
  return clampCamera({ scale, x: b.x - (a.x - c.x) * ratio, y: b.y - (a.y - c.y) * ratio }, width);
}
